import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MiniCartModel, PriceTypeQuantity } from "../interfaces/types";

const initialState: MiniCartModel = (window as any).miniCartModel ? (window as any).miniCartModel : null;

const miniCartModelSlice = createSlice({
    name: 'mini-cart-model-slice',
    initialState,
    reducers: {
        clearMiniCart: (state, action: PayloadAction) => {
            let emptyMiniCart: MiniCartModel = {
                priceTypeQuantities: [],
                subtotal: 0,
                disableAddToCartButton: true,
                showError: false,
                errorMessage: "",
                minimumPriceTypeQuantityMessage: state.minimumPriceTypeQuantityMessage
            }
            return state = emptyMiniCart;
        },
        updateMiniCartState: (state, action: PayloadAction<PriceTypeQuantity>) => {
            let newMiniCart: MiniCartModel = {
                priceTypeQuantities: [],
                subtotal: 0,
                disableAddToCartButton: true,
                showError: state.showError,
                errorMessage: state.errorMessage,
                minimumPriceTypeQuantityMessage: state.minimumPriceTypeQuantityMessage
            }
            const newPriceType = action.payload;

            //pt => empty list, add 2
            if (state.priceTypeQuantities.length == 0 && newPriceType.quantity > 0) {
                newMiniCart.priceTypeQuantities.push(newPriceType);
                newMiniCart.subtotal = newPriceType.totalAmount;
            } else if (state.priceTypeQuantities.length > 0) {
                state.priceTypeQuantities.map(priceType => {
                    if (priceType.priceTypeId === newPriceType.priceTypeId && priceType.zoneId === newPriceType.zoneId) {
                        newMiniCart.priceTypeQuantities.push(newPriceType);
                        newMiniCart.subtotal += newPriceType.totalAmount;
                    }
                    else if (priceType.quantity > 0) {
                        newMiniCart.priceTypeQuantities.push(priceType);
                        newMiniCart.subtotal += priceType.totalAmount;
                    }
                });

                if (state.priceTypeQuantities.filter(item => item.priceTypeId == newPriceType.priceTypeId && item.zoneId === newPriceType.zoneId).length == 0) {
                    newMiniCart.priceTypeQuantities.push(newPriceType);
                    newMiniCart.subtotal += newPriceType.totalAmount;
                }
            }

            newMiniCart.priceTypeQuantities = newMiniCart.priceTypeQuantities.filter(item => item.quantity > 0);

            // Check all price types in the cart meet their minimums
            newMiniCart.disableAddToCartButton = newMiniCart.priceTypeQuantities.length === 0;
            newMiniCart.showError = false;
            newMiniCart.errorMessage = "";
            var checkedIds: number[] = [];
            newMiniCart.priceTypeQuantities.forEach(item => {
                if (checkedIds.indexOf(item.priceTypeId) === -1) {
                    checkedIds.push(item.priceTypeId);
                    var total = newMiniCart.priceTypeQuantities.filter(pt => pt.priceTypeId === item.priceTypeId)?.reduce((sum, pt) => sum + pt.quantity, 0);
                    if (item.minQuantity > 0 && total < item.minQuantity) {
                        newMiniCart.disableAddToCartButton = true;
                        newMiniCart.showError = true;
                        newMiniCart.errorMessage = newMiniCart.minimumPriceTypeQuantityMessage.replace(/\{0\}/g, item.minQuantity.toString());
                    }
                }
            });

            return state = newMiniCart;
        },
        replaceMiniCart: (state, action: PayloadAction<MiniCartModel>) => {
            return state = action.payload;
        }
    },
})

export default miniCartModelSlice;